import $ from "jquery";

export default function () {
	// Initialize search when document is ready
	$(document).ready(function () {
		initSearch();
	});

	/**
	 * Initialize search functionality
	 */
	function initSearch() {
		// Parse translation data passed from PHP
		let translationData = {};
		try {
			// Check if translation_data exists and is a non-empty string
			if (dr && dr.js_data && dr.js_data.translation_data && typeof dr.js_data.translation_data === "string") {
				translationData = JSON.parse(dr.js_data.translation_data);
			} else {
				// Provide fallback default strings if parsing fails or data is missing
				translationData = {
					message: {
						resource_found: "<span>1</span> resource found",
						resources_found: "<span>%d</span> resources found",
					},
				};
			}
		} catch (e) {
			// Provide fallback default strings on error
			translationData = {
				message: {
					resource_found: "<span>1</span> resource found",
					resources_found: "<span>%d</span> resources found",
				},
			};
		}

		const searchForm = $("#search-results");
		const hitsContainer = $("#hits");
		const paginationContainer = $("#pagination");
		const statsContainer = $("#stats");
		const currentRefinementsContainer = $(".ais-CurrentRefinements");
		const featuredPostsContainer = $(".resourceArchive__featured");
		const skeletonContainer = $("#hits_skeleton");

		// Initially hide hits and show skeleton
		if (hitsContainer.length && skeletonContainer.length) {
			hitsContainer.addClass("uk-hidden");
			skeletonContainer.addClass("uk-visible");
		}

		// Add performance tracking variables
		let perfMetrics = {
			initialPageLoad: 0,
			filterSearch: 0,
			paginationSearch: 0,
			lastSearchStart: 0,
			isInitialLoad: true,
		};

		// Immediately hide featured container if any filters (standard or Algolia) are present in the URL
		// Featured container is hidden by default in Twig.
		// Show it only if NO filters are present in the URL initially.
		const initialUrlParams = new URLSearchParams(window.location.search);
		let hasInitialFilters = false;
		let hasAlgoliaFilters = false; // Flag specifically for Algolia params
		initialUrlParams.forEach((value, key) => {
			if (key.startsWith("filter_") || key.startsWith("refinementList")) {
				if (value) {
					// Ensure the filter has a non-empty value
					hasInitialFilters = true;
					if (key.startsWith("refinementList")) {
						hasAlgoliaFilters = true;
					}
				}
			}
		});
		if (!hasInitialFilters && featuredPostsContainer.length) {
			// Only remove uk-hidden if no filters were found
			featuredPostsContainer.removeClass("uk-hidden");
		}

		// Initial check for featured container - add uk-hidden class if it has no slides
		if (featuredPostsContainer.length && featuredPostsContainer.find(".swiper-slide").length === 0) {
			featuredPostsContainer.addClass("uk-hidden");
		}

		// Ensure refinements container exists
		let refinementsContainer = $(".ais-CurrentRefinements");
		if (!refinementsContainer.length) {
			// If container doesn't exist, create it just before the hits container
			hitsContainer.before('<div class="ais-CurrentRefinements uk-margin-large-bottom" style="display:none;"></div>');
			refinementsContainer = $(".ais-CurrentRefinements");
		}

		// Clear any existing content in the refinements container to start fresh
		refinementsContainer.empty().hide();

		// Initialize stats container using translations
		if (statsContainer.length) {
			const total = statsContainer.data("total") || 0;
			let statsHtml;
			if (total === 1) {
				// Use resource_found, no need to replace %d as it's hardcoded '1' in the string
				statsHtml = translationData.message.resource_found || "<span>1</span> resource found";
			} else {
				// Use resources_found, replace %d with total
				statsHtml = (translationData.message.resources_found || "<span>%d</span> resources found").replace("%d", total);
			}
			statsContainer.html(`<div class="uk-h4 uk-margin-remove">${statsHtml}</div>`);
			statsContainer.data("total", total); // Ensure data attribute is set
		}

		// If search form not present, return
		if (!searchForm.length) {
			return;
		}

		// Remove all existing document events to prevent duplication
		$(document).off("click", ".filter-tag");
		$(document).off("click", ".ais-ClearRefinements-button");
		$(document).off("click", ".pagination-link");
		$(document).off("click", ".tab-filter");

		// Save current search state
		let currentState = {
			query: "",
			page: 1,
			filters: {},
			loading: false,
			initialLoadComplete: false,
			abortController: null, // Added for aborting fetch requests
			isPaginationClick: false, // Flag for pagination clicks
		};

		// Handle tabs filter clicks (for partner_type and other tab filters)
		$(document).on("click", ".tab-filter", function (e) {
			e.preventDefault();

			const filterType = $(this).data("filter-type");
			const filterValue = $(this).data("filter-value");

			// Clear any existing values for this filter type
			delete currentState.filters[filterType];

			// Add the new value
			if (filterValue) {
				currentState.filters[filterType] = [filterValue];
			}

			// Update active tab class
			$(this).closest("ul").find("li").removeClass("uk-active");
			$(this).closest("li").addClass("uk-active");

			// Update refinement tags
			updateRefinementTags(currentState.filters);

			// Reset to page 1 when filters change
			currentState.page = 1;

			// Update available filters and perform search
			updateAvailableFilters(currentState.filters);
			performSearch(1);
		});

		// Setup results cache to avoid unnecessary requests
		const resultsCache = {};

		// Function to get cache key based on search parameters
		function getCacheKey(query, page, filters) {
			return JSON.stringify({
				q: query,
				p: page,
				f: filters,
			});
		}

		// First initialize from URL parameters
		initializeFromURL();

		// Then perform an initial search to load results
		performSearch(currentState.page);

		// Attach event handlers to the search form and buttons
		function setupFormHandlers() {
			// Optimize checkbox handling with direct binding
			searchForm.find('input[type="checkbox"]').on("change", function () {
				// Get the filter type and value
				const filterParts = $(this)
					.attr("name")
					.match(/filters\[(.*?)\]/);
				if (!filterParts) return;

				const filterType = filterParts[1];
				const filterValue = $(this).val();
				const isChecked = $(this).is(":checked");

				// Initialize array if it doesn't exist
				if (!currentState.filters[filterType]) {
					currentState.filters[filterType] = [];
				}

				// Add or remove the filter
				if (isChecked) {
					// Add selection class to the list item for visual indicator
					$(this).closest("li.ais-RefinementList-item").addClass("ais-RefinementList-item--selected");

					// Add value to filters if not already present
					if (!currentState.filters[filterType].includes(filterValue)) {
						currentState.filters[filterType].push(filterValue);
					}
				} else {
					// Remove selection class from the list item
					$(this).closest("li.ais-RefinementList-item").removeClass("ais-RefinementList-item--selected");

					// Remove value from filters
					const index = currentState.filters[filterType].indexOf(filterValue);
					if (index !== -1) {
						currentState.filters[filterType].splice(index, 1);
					}

					// Remove the filter type entirely if no values remain
					if (currentState.filters[filterType].length === 0) {
						delete currentState.filters[filterType];
					}
				}

				// Update tabs UI if the filter type has tabs
				if (filterType === "partner_type") {
					$("#partner_type-tabs-list li").removeClass("uk-active");
					if (currentState.filters[filterType] && currentState.filters[filterType].length > 0) {
						$(`#partner_type-tabs-list a[data-filter-value="${filterValue}"]`).closest("li").addClass("uk-active");
					} else {
						// If no filter selected, make "All" active
						$("#partner_type-tabs-list li:first-child").addClass("uk-active");
					}
				}

				// CRUCIAL: Always update the tags display immediately for better user experience
				// This must be called before performSearch to ensure visibility on first selection
				updateRefinementTags(currentState.filters);

				// Reset to page 1 when filters change
				currentState.page = 1;

				// Update available filters based on the new filter state
				updateAvailableFilters(currentState.filters);

				// Show loading indicator and run search
				performSearch(1);
			});
		}

		// Call the setupFormHandlers function to bind events
		setupFormHandlers();

		// Handle search input submit
		searchForm.on("submit", function (e) {
			e.preventDefault();
			// Reset to page 1 for new searches
			currentState.page = 1;
			performSearch(1);
		});

		// Optimize search input handling with debounce
		// This prevents excessive searches as the user types
		let searchTimer = null;
		searchForm.find('input[type="text"]').on("keyup", function (e) {
			clearTimeout(searchTimer);

			if (e.keyCode === 13) {
				e.preventDefault();
				currentState.page = 1;
				performSearch(1);
			} else {
				// Wait 500ms after typing stops before searching
				searchTimer = setTimeout(function () {
					currentState.page = 1;
					performSearch(1);
				}, 500);
			}
		});

		// Optimize pagination click handling with direct binding rather than delegation
		function setupPaginationHandlers() {
			paginationContainer
				.find(".pagination-link")
				.off("click")
				.on("click", function (e) {
					e.preventDefault();
					const page = parseInt($(this).data("page"));

					// Only perform search if page is different
					if (page !== currentState.page) {
						currentState.page = page;
						currentState.isPaginationClick = true; // Set flag before search
						performSearch(page);
					}
				});
		}

		/**
		 * Initialize search from URL parameters
		 */
		function initializeFromURL() {
			const urlParams = new URLSearchParams(window.location.search);
			const page = parseInt(urlParams.get("page") || "1");
			const searchQuery = urlParams.get("s") || "";

			// Set search input value from URL
			if (searchQuery) {
				searchForm.find('input[type="text"]').val(searchQuery);
			}

			// Initialize empty filters
			const filters = {};

			// Set filter checkboxes based on URL parameters
			urlParams.forEach((value, key) => {
				if (key.startsWith("filter_")) {
					const filterName = key.replace("filter_", "");

					// Handle comma-separated values
					const values = value.split(",");
					// Store filter values in the currentState
					if (!filters[filterName]) {
						filters[filterName] = [];
					}
					// Check the corresponding checkboxes for each value
					values.forEach((val) => {
						// Trim value to avoid whitespace issues
						const trimmedVal = val.trim();
						if (trimmedVal) {
							const checkbox = searchForm.find(`input[name="filters[${filterName}][]"][value="${trimmedVal}"]`);
							if (checkbox.length) {
								checkbox.prop("checked", true);
								checkbox.closest("li.ais-RefinementList-item").addClass("ais-RefinementList-item--selected");

								// Only add unique values to the filters array
								if (!filters[filterName].includes(trimmedVal)) {
									filters[filterName].push(trimmedVal);
								}
							}
						}
					});
				} else if (key.startsWith("refinementList[")) {
					// Parse Algolia's refinementList format
					const match = key.match(/refinementList\[(.*?)\]\[(\d+)\]/);
					if (match) {
						const algoliaFilterName = match[1];
						const filterValue = decodeURIComponent(value.trim()); // Decode URL-encoded values
						// Map Algolia filter name to internal filter name
						let filterName;
						if (algoliaFilterName === "type.label") {
							filterName = "resource_type"; // Map Algolia's type.label to resource_type
						} else {
							filterName = algoliaFilterName; // Use the original name if not mapped
						}
						// Find the checkbox by matching its LABEL text with the Algolia filterValue
						let correctValueForFilter = null; // Variable to store the correct value

						searchForm.find(`input[name="filters[${filterName}][]"]`).each(function () {
							const checkbox = $(this);
							const labelElement = checkbox.closest("label").find("span.uk-width-expand");
							if (labelElement.length) {
								const labelText = labelElement.text().trim();
								const checkboxValue = checkbox.val();

								if (labelText.toLowerCase() === filterValue.toLowerCase()) {
									correctValueForFilter = checkboxValue;
									return false; // Stop iterating .each()
								}
							}
						});

						// If we found the correct value by matching the label, find the checkbox by that value and check it
						if (correctValueForFilter !== null) {
							// Escape single quotes in value for the selector
							const escapedValue = correctValueForFilter.replace(/'/g, "\\\\'");
							const checkboxWithValue = searchForm.find(`input[name="filters[${filterName}][]"][value='${escapedValue}']`);

							if (checkboxWithValue.length > 0) {
								checkboxWithValue.prop("checked", true);
								checkboxWithValue.closest("li.ais-RefinementList-item").addClass("ais-RefinementList-item--selected");

								// Add the correct value to the filters object
								if (!filters[filterName]) {
									filters[filterName] = [];
								}
								if (!filters[filterName].includes(correctValueForFilter)) {
									filters[filterName].push(correctValueForFilter);
								}
							}
						}
					}
				}
			});

			// Update current state with filters from URL
			currentState.filters = filters;
			currentState.query = searchQuery;
			currentState.page = page;

			// Always update refinement tags on page load,
			// even if no filters are active (to properly hide/show the container)
			updateRefinementTags(filters);

			// Initialize available filters based on URL parameters.
			if (Object.keys(filters).length > 0) {
				updateAvailableFilters(filters);
			}
			// Call the toggle function after initializing state from URL
			toggleFeaturedPostsVisibility();
		}

		/**
		 * Perform search with current form values and filters
		 *
		 * @param {number} page - The page number
		 */
		function performSearch(page = 1) {
			// Prevent multiple simultaneous searches (this check might be redundant with abortController, but safe to keep)
			if (currentState.loading) {
				// Abort previous request if it exists
				currentState.abortController?.abort("New search started");
			}

			currentState.loading = true;

			// Start performance timing.
			perfMetrics.lastSearchStart = performance.now();

			// Show skeleton and hide hits container - no need to do this again if already done initially
			if (!perfMetrics.isInitialLoad && skeletonContainer && skeletonContainer.length) {
				skeletonContainer.addClass("uk-visible");
				hitsContainer.addClass("uk-hidden");
			}

			// Create a new AbortController for this request
			const controller = new AbortController();
			currentState.abortController = controller; // Store the controller

			// Get search query from input
			const searchQuery = searchForm.find('input[type="text"]').val() || "";

			// Get post type if available
			const postType = searchForm.data("post-type") || "resource";

			// Update only the query part of the current state here
			currentState.query = searchQuery;
			const filters = currentState.filters; // Use the already updated filters from currentState

			// Important: Update the UI before making the AJAX request
			// This provides immediate feedback to the user
			updateRefinementTags(currentState.filters); // Use current state

			// Check cache first
			const cacheKey = getCacheKey(searchQuery, page, filters);
			if (resultsCache[cacheKey]) {
				processResults(resultsCache[cacheKey]);
				return;
			}

			// Check if drAjax is defined
			if (typeof drAjax === "undefined" || !drAjax.ajaxurl) {
				if (hitsContainer.length) {
					hitsContainer.html('<div class="uk-alert uk-alert-danger">Error: AJAX configuration not found. Please contact the administrator.</div>');
					hitsContainer.find(".uk-overlay").remove();
					hitsContainer.removeClass("uk-position-relative uk-hidden");
					if (skeletonContainer && skeletonContainer.length) {
						skeletonContainer.removeClass("uk-visible");
					}
				}
				currentState.loading = false;
				return;
			}

			// Determine posts per page based on body class
			const postsPerPage = $("body").hasClass("resource-two-col") ? 8 : 12;

			// Build form data for AJAX request
			const formData = new FormData();
			formData.append("action", "ajax_search");
			formData.append("nonce", drAjax.nonce);
			formData.append("query", searchQuery);
			formData.append("post_type", postType);
			formData.append("page", page);
			formData.append("per_page", postsPerPage); // Use dynamic value
			formData.append("filters", JSON.stringify(currentState.filters)); // Use current state

			// Performance optimization: Use fetch API instead of jQuery AJAX
			// This is more efficient and uses less memory
			fetch(drAjax.ajaxurl, {
				method: "POST",
				body: formData,
				credentials: "same-origin",
				signal: controller.signal, // Pass the signal to fetch
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error("Network response was not ok");
					}
					return response.json();
				})
				.then((response) => {
					// Cache the successful results (store a copy to prevent reference issues)
					if (response.success && response.data) {
						resultsCache[cacheKey] = JSON.parse(JSON.stringify(response));
					}

					processResults(response);
				})
				.catch((error) => {
					// Check if the error was due to aborting the request.
					// Check error name, error message, or if the error itself is the abort reason string.
					if ((error instanceof Error && (error.name === "AbortError" || error.message === "New search started")) || error === "New search started") {
						// Don't show generic error message if it was just an abort.
						// Reset loading state as the request is finished (aborted).
						currentState.loading = false;
					} else {
						// Log the actual error for debugging.
						if (hitsContainer.length) {
							// Show error message only for non-abort errors.
							hitsContainer.html('<div class="uk-alert uk-alert-danger">Error loading results. Please try again.</div>');
						}
						// Reset loading state on error.
						currentState.loading = false;
					}
				});

			/**
			 * Process and display search results
			 */
			function processResults(response) {
				// Calculate performance timing.
				const endTime = performance.now();
				const duration = endTime - perfMetrics.lastSearchStart;

				// Add detailed output of posts loading time to console
				// console.log(`Total posts loading time: ${duration.toFixed(2)} ms`);
				// console.log(`Request type: ${perfMetrics.isInitialLoad ? "Initial load" : currentState.isPaginationClick ? "Pagination" : "Filtering"}`);

				// Record performance metrics based on search type.
				if (perfMetrics.isInitialLoad) {
					perfMetrics.initialPageLoad = duration;
					perfMetrics.isInitialLoad = false;
				} else if (currentState.isPaginationClick) {
					perfMetrics.paginationSearch = duration;
				} else {
					perfMetrics.filterSearch = duration;
				}

				// Check if the response is for the current state page
				if (response.success && response.data && response.data.current_page !== currentState.page) {
					// Do not reset loading here, finally block will handle it.
					return; // Ignore stale results
				}

				if (response.success && response.data) {
					// Add performance stats to the page if stats container exists.
					if (statsContainer.length) {
						// Update the existing stats element with performance data.
						const total = response.data.total;
						updateStats(total, duration);
					}

					// Update URL parameters
					// Pass the CURRENT filters from currentState, as these reflect the state that generated the results
					updateURLParameters(currentState.query, currentState.page, currentState.filters);

					// Scroll to top ONLY if it was a pagination click
					if (currentState.isPaginationClick && hitsContainer.length) {
						$("html, body").animate(
							{
								scrollTop: hitsContainer.offset().top - 100,
							},
							300 // Restore duration for smooth scroll
						);
						// Reset the flag after scrolling
						currentState.isPaginationClick = false;
					}

					// Update hit container with HTML
					if (hitsContainer.length) {
						// First update HTML but keep it hidden.
						hitsContainer.html(response.data.html);

						// After updating the data, hide skeleton and show content with a small delay.
						if (skeletonContainer && skeletonContainer.length) {
							setTimeout(function () {
								skeletonContainer.removeClass("uk-visible");
								hitsContainer.removeClass("uk-hidden");
							}, 200);
						}

						// After updating the hit container, check if featured posts exist and toggle visibility
						const hasActiveFilters = Object.keys(filters).some((key) => Array.isArray(filters[key]) && filters[key].length > 0);
						toggleFeaturedPostsVisibility();
					}

					// Update pagination
					if (paginationContainer.length) {
						// Update data attributes with pagination info
						paginationContainer.attr("data-total-pages", response.data.pages);
						paginationContainer.attr("data-current-page", response.data.current_page);

						// Generate pagination UI
						updatePagination(response.data.current_page, response.data.pages, response.data.total);
					}

					// No need to update refinement tags here anymore
					// The updateRefinementTags function was already called before the AJAX request
					// This avoids update flicker and double rendering
					currentState.loading = false;
				} else {
					if (hitsContainer.length) {
						hitsContainer.html('<div class="uk-alert uk-alert-danger">Error loading results. Please try again.</div>');

						// In case of error, also hide skeleton and show error message.
						if (skeletonContainer && skeletonContainer.length) {
							skeletonContainer.removeClass("uk-visible");
						}
						hitsContainer.removeClass("uk-hidden");
					}
				}
			}
		}

		/**
		 * Update the refinement tags display to show currently selected filters
		 *
		 * @param {Object} filters - The current filter values
		 */
		function updateRefinementTags(filters) {
			// Find the refinements container
			let refinementsContainer = $(".ais-CurrentRefinements");

			// If container doesn't exist, create it
			if (!refinementsContainer.length) {
				$("#hits").before('<div class="ais-CurrentRefinements uk-margin-large-bottom" style="display:none;"></div>');
				refinementsContainer = $(".ais-CurrentRefinements");
			}

			// Always remove all existing content and handlers first
			refinementsContainer.empty();

			// Check if there are active filters
			const hasActiveFilters = Object.keys(filters).some((key) => Array.isArray(filters[key]) && filters[key].length > 0);

			// Toggle featured posts container based on active filters
			toggleFeaturedPostsVisibility();

			// If no active filters, keep the container empty and hidden
			if (!hasActiveFilters) {
				refinementsContainer.hide();
				return;
			}

			// Create a clean HTML structure for the refinement tags
			let html = '<div class="uk-grid uk-grid-xsmall uk-flex-middle" uk-grid>';

			// Add tags for each selected filter
			Object.entries(filters).forEach(([filterKey, values]) => {
				if (Array.isArray(values) && values.length > 0) {
					// Use Set to ensure unique values
					const uniqueValues = [...new Set(values)];

					uniqueValues.forEach((value) => {
						// --- Start: Improved label finding ---
						let filterLabel = value; // Default fallback label is the value itself.

						// Attempt 1: Check if it's a tab filter and get label from the tab link.
						const tabLink = $(".tab-filter[data-filter-type='" + filterKey + "'][data-filter-value='" + value + "']");
						if (tabLink.length > 0) {
							filterLabel = tabLink.text().trim();
						} else {
							// Attempt 2: Fallback to finding the label from a checkbox input if not found in tabs.
							const filterInput = searchForm.find(`input[name="filters[${filterKey}][]"][value="${value}"]`);
							if (filterInput.length) {
								const labelElement = filterInput.closest("label").find("span.uk-width-expand");
								if (labelElement.length) {
									// Try to get the primary text node first for cleaner labels
									const textNode = labelElement[0].firstChild;
									if (textNode && textNode.nodeType === 3) {
										// Node.TEXT_NODE
										filterLabel = textNode.nodeValue.trim();
									} else {
										// Fallback to full text if no simple text node found
										filterLabel = labelElement.text().trim();
									}
								}
							}
						}
						// --- End: Improved label finding ---

						// Add tag HTML - use precise HTML structure matching Algolia's pattern
						html += `
							<div>
								<button class="filter-tag uk-button uk-button-indigo-outline uk-flex uk-flex-middle" 
									data-filter="${filterKey}" 
									data-value="${value}">
									${filterLabel}
									<span class="uk-margin-xsmall-left uk-icon" uk-icon="icon: close"></span>
								</button>
							</div>
						`;
					});
				}
			});

			// Add the clear button with consistent styling
			html += `
				<div>
					<a href="#" class="uk-button uk-link-indigo uk-button-link ais-ClearRefinements-button">
						${searchForm.data("clear-filters-text") || "Clear filters"}
					</a>
				</div>
			`;

			html += "</div>";

			// Replace the entire content of the container and make sure it's visible
			refinementsContainer.html(html).show();

			// Remove any existing event handlers to prevent duplicates
			refinementsContainer.find(".filter-tag").off();
			refinementsContainer.find(".ais-ClearRefinements-button").off();

			// Add new click handlers for filter tags
			refinementsContainer.find(".filter-tag").on("click", function (e) {
				e.preventDefault();
				e.stopPropagation();

				const filter = $(this).data("filter");
				const value = $(this).data("value");

				// --- Start: Updated Filter Removal Logic ---

				// 1. Always remove the filter from the state first.
				if (currentState.filters[filter]) {
					const index = currentState.filters[filter].indexOf(value);
					if (index !== -1) {
						currentState.filters[filter].splice(index, 1);
					}
					// If the filter array is now empty, remove the filter key.
					if (currentState.filters[filter].length === 0) {
						delete currentState.filters[filter];
					}
				}

				// 2. Update the corresponding UI element (checkbox or tab).
				// Attempt to find the checkbox.
				const checkbox = searchForm.find(`input[name="filters[${filter}][]"][value="${value}"]`);
				if (checkbox.length) {
					// If checkbox found, uncheck it.
					checkbox.prop("checked", false);
					checkbox.closest("li.ais-RefinementList-item").removeClass("ais-RefinementList-item--selected");
				} else {
					// If no checkbox, check if it was a tab filter.
					const tabLink = $(".tab-filter[data-filter-type='" + filter + "'][data-filter-value='" + value + "']");
					if (tabLink.length > 0) {
						const tabListItem = tabLink.closest("li");
						// Only update tabs if the one being removed was actually active.
						if (tabListItem.hasClass("uk-active")) {
							const tabList = tabListItem.closest("ul");
							if (tabList.length > 0) {
								tabList.find("li").removeClass("uk-active");
								// Activate the "All" tab (first li).
								tabList.find("li:first-child").addClass("uk-active");
							}
						}
					}
				}

				// 3. Common actions: Reset page, update filters, perform search.
				currentState.page = 1;
				updateAvailableFilters(currentState.filters);
				performSearch(1);

				// --- End: Updated Filter Removal Logic ---
			});

			// Add new click handler for clear all button
			refinementsContainer.find(".ais-ClearRefinements-button").on("click", function (e) {
				e.preventDefault();
				e.stopPropagation();

				// Clear all checkboxes and remove selected class
				searchForm.find('input[type="checkbox"]:checked').prop("checked", false);
				searchForm.find("li.ais-RefinementList-item--selected").removeClass("ais-RefinementList-item--selected");

				// Clear all filters from currentState
				currentState.filters = {};

				// Reset all tab filters to "All".
				$(".tab-filter").each(function () {
					const tabList = $(this).closest("ul");
					// Prevent multiple resets for the same list.
					if (tabList.length > 0 && !tabList.data("reset-handled")) {
						tabList.find("li").removeClass("uk-active");
						tabList.find("li:first-child").addClass("uk-active");
						// Mark as handled.
						tabList.data("reset-handled", true);
					}
				});
				// Clean up handler flag after processing.
				$("ul[data-reset-handled]").removeData("reset-handled");

				// Reset to page 1 when filters change
				currentState.page = 1;

				// Update available filters after clearing all filters
				updateAvailableFilters({});
				// Call the toggle function after clearing filters
				toggleFeaturedPostsVisibility();

				performSearch(1);
			});
		}

		/**
		 * Toggle featured posts visibility based on filter status and pagination
		 * Hides if filters are active OR current page is not 1.
		 */
		function toggleFeaturedPostsVisibility() {
			// Target the specific featured posts container
			if (!featuredPostsContainer || !featuredPostsContainer.length) {
				return;
			}

			// Check if there are any featured posts (swiper slides) in the container
			const hasFeaturedSlides = featuredPostsContainer.find(".swiper-slide").length > 0;
			// Check if any filters are currently active in the state
			const hasActiveFilters = Object.keys(currentState.filters).some((key) => Array.isArray(currentState.filters[key]) && currentState.filters[key].length > 0);
			// Check if the current page is not the first one
			const isNotFirstPage = currentState.page > 1;

			// Determine if the container should be shown
			// Show only if: No filters are active AND it's the first page AND there are slides to show
			const shouldShow = !hasActiveFilters && !isNotFirstPage && hasFeaturedSlides;

			// Simple class toggle approach
			if (shouldShow) {
				// Add class if not already present
				if (featuredPostsContainer.hasClass("uk-hidden")) {
					featuredPostsContainer.removeClass("uk-hidden");

					// Trigger window resize to ensure any sliders reinitialize properly
					$(window).trigger("resize");
				}
			} else {
				// Add class if not already present
				if (!featuredPostsContainer.hasClass("uk-hidden")) {
					featuredPostsContainer.addClass("uk-hidden");
				}
			}
		}

		/**
		 * Update pagination UI
		 *
		 * @param {number} currentPage - Current page number
		 * @param {number} totalPages - Total number of pages
		 * @param {number} totalPosts - Total number of posts
		 */
		function updatePagination(currentPage, totalPages, totalPosts) {
			if (!paginationContainer.length || totalPosts === 0 || totalPages <= 1) {
				paginationContainer.empty();
				return;
			}

			let html = '<ul class="uk-pagination uk-flex-center">';

			// Previous page
			if (currentPage > 1) {
				html += `<li><a class="pagination-link" data-page="${currentPage - 1}" href="#"><span uk-pagination-previous></span></a></li>`;
			}

			// Calculate page range to show (show up to 5 pages)
			let startPage = Math.max(1, currentPage - 2);
			let endPage = Math.min(totalPages, startPage + 3);

			// Adjust if we're near the end
			if (endPage - startPage < 4 && startPage > 1) {
				startPage = Math.max(1, endPage - 3);
			}

			// First page + ellipsis
			if (startPage > 1) {
				html += `<li><a class="pagination-link" data-page="1" href="#">1</a></li>`;
				if (startPage > 2) {
					html += `<li class="uk-disabled"><span>...</span></li>`;
				}
			}

			// Page numbers
			for (let i = startPage; i <= endPage; i++) {
				if (i === currentPage) {
					html += `<li class="uk-active"><span>${i}</span></li>`;
				} else {
					html += `<li><a class="pagination-link" data-page="${i}" href="#">${i}</a></li>`;
				}
			}

			// Last page + ellipsis
			if (endPage < totalPages) {
				if (endPage < totalPages - 1) {
					html += `<li class="uk-disabled"><span>...</span></li>`;
				}
				html += `<li><a class="pagination-link" data-page="${totalPages}" href="#">${totalPages}</a></li>`;
			}

			// Next page
			if (currentPage < totalPages) {
				html += `<li><a class="pagination-link" data-page="${currentPage + 1}" href="#"><span uk-pagination-next></span></a></li>`;
			}

			html += "</ul>";
			paginationContainer.html(html);

			// Setup click handlers for the new pagination links
			setupPaginationHandlers();
		}

		/**
		 * Update URL parameters without page reload
		 *
		 * @param {string} query - Search query
		 * @param {number} page - Page number
		 * @param {Object} filters - Filter values
		 */
		function updateURLParameters(query, page, filters) {
			const params = new URLSearchParams();

			// Add search query to URL
			if (query) {
				params.append("s", query);
			}

			// Add filters to URL - use separate parameter for each filter category
			Object.entries(filters).forEach(([key, values]) => {
				if (values && values.length > 0) {
					// Ensure values are unique
					const uniqueValues = [...new Set(values)];
					// Use a single filter_* parameter with comma-separated values
					params.append(`filter_${key}`, uniqueValues.join(","));
				}
			});

			// Add page to URL (only if not page 1)
			if (page > 1) {
				params.append("page", page);
			}

			// Update URL without reloading the page
			const newURL = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
			window.history.pushState({}, "", newURL);
		}

		// Add new function for updating available filters
		/**
		 * Update available filters based on current selection
		 *
		 * @param {Object} filters - Currently selected filters
		 */
		function updateAvailableFilters(filters) {
			// Take a snapshot of current visibility state
			const visibilitySnapshot = {};
			searchForm.find(".ais-RefinementList-item").each(function () {
				const $item = $(this);
				const checkbox = $item.find('input[type="checkbox"]');
				if (checkbox.length) {
					const name = checkbox.attr("name");
					const value = checkbox.val();
					visibilitySnapshot[`${name}:${value}`] = !$item.hasClass("uk-hidden");
				}
			});

			// Build form data for AJAX request
			const formData = new FormData();
			formData.append("action", "ajax_get_available_filters");
			formData.append("nonce", drAjax.nonce);
			formData.append("filters", JSON.stringify(filters));

			// Add context parameter to get the right filters
			const postType = searchForm.data("post-type") || "resource";
			formData.append("context", postType);

			// Use fetch API for better performance
			fetch(drAjax.ajaxurl, {
				method: "POST",
				body: formData,
				credentials: "same-origin",
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error("Network response was not ok");
					}
					return response.json();
				})
				.then((response) => {
					if (response.success && response.data) {
						// Check if we have active filters
						const hasActiveFilters = Object.keys(filters).some((key) => Array.isArray(filters[key]) && filters[key].length > 0);

						// Process the filter results with this information
						processFilterResults(response.data, hasActiveFilters, visibilitySnapshot);
					}
				})
				.catch((error) => {
					// Handle filter update error silently
				});
		}

		/**
		 * Process and update filter options based on available filters
		 *
		 * @param {Object} filterData - Filter data from server
		 * @param {boolean} hasActiveFilters - Whether there are active filters
		 * @param {Object} previousVisibility - Previous visibility state
		 */
		function processFilterResults(filterData, hasActiveFilters, previousVisibility) {
			// If no active filters, show all filter items
			if (!hasActiveFilters) {
				// Show all filter items across all filter groups
				searchForm.find(".ais-RefinementList-item").removeClass("uk-hidden");
			}

			// Process each filter group
			Object.keys(filterData).forEach((filterName) => {
				const filterGroup = filterData[filterName];
				if (!filterGroup || !filterGroup.terms) {
					return;
				}

				// Handle visibility based on active filters
				if (hasActiveFilters) {
					// Create a set of values from the server response for quick lookup
					const serverValues = new Set(filterGroup.terms.map((term) => term.value));

					// Process all checkboxes for this filter
					searchForm.find(`input[name="filters[${filterName}][]"]`).each(function () {
						const $checkbox = $(this);
						const value = $checkbox.val();
						const $item = $checkbox.closest("li.ais-RefinementList-item");

						// If value is in server response or checkbox is checked, show the item
						if (serverValues.has(value) || $checkbox.is(":checked")) {
							$item.removeClass("uk-hidden");
						} else {
							// Otherwise hide it
							$item.addClass("uk-hidden");
						}
					});
				}

				// Always update the count for each term
				filterGroup.terms.forEach((term) => {
					const checkbox = searchForm.find(`input[name="filters[${filterName}][]"][value="${term.value}"]`);
					if (checkbox.length) {
						// Update the count
						const countEl = checkbox.closest("label").find(".ais-RefinementList-count");
						if (countEl.length) {
							countEl.text(`${term.count}`);
						}
					}
				});
			});

			// Final verification check
			if (!hasActiveFilters) {
				const stillHidden = [];
				searchForm.find(".ais-RefinementList-item.uk-hidden").each(function () {
					const $item = $(this);
					const checkbox = $item.find('input[type="checkbox"]');
					if (checkbox.length) {
						stillHidden.push({
							name: checkbox.attr("name"),
							value: checkbox.val(),
						});
					}
				});
			}
		}

		function updateStats(total, duration = null) {
			const stats = document.getElementById("stats");
			if (stats) {
				stats.dataset.total = total; // Update data attribute
				let statsHtml;
				if (total === 1) {
					// Use resource_found
					statsHtml = translationData.message.resource_found || "<span>1</span> resource found";
				} else {
					// Use resources_found, replace %d with total
					statsHtml = (translationData.message.resources_found || "<span>%d</span> resources found").replace("%d", total);
				}

				// Update the entire inner HTML
				stats.innerHTML = `<div class="uk-h4 uk-margin-remove">${statsHtml}</div>`;
			}
		}
	}
}
